import { forwardRef } from "react";
import { HeadingProps, HeadingRefType } from "./types";

const Heading = forwardRef<HeadingRefType, HeadingProps>((props, ref) => {
  const { children, color, className = "", size = 15, textStyles = {} } = props;
  return (
    <h1
      style={{
        color,
        fontSize: size,
        fontFamily: "IranSansBold",
        ...textStyles,
      }}
      className={className}
      ref={ref}
    >
      {children}
    </h1>
  );
});

export default Heading;
